import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './layouts/admin';
import { Alert, AlertIcon, Box, ChakraProvider, Spinner } from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState } from 'react';
import { FinanceProvider, useFinance } from 'contexts/FinanceContext';

function AppRoutes({ theme }: { theme: typeof initialTheme }) {
  const { ready, storageError } = useFinance();

  if (!ready) {
    return (
      <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
        <Spinner size="lg" color="brand.500" thickness="3px" />
      </Box>
    );
  }

  return (
    <>
      {storageError && (
        <Alert status="warning" borderRadius="0">
          <AlertIcon />
          {storageError}
        </Alert>
      )}
      <Routes>
        <Route
          path="admin/*"
          element={<AdminLayout theme={theme} setTheme={() => {}} />}
        />
        <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
      </Routes>
    </>
  );
}

export default function Main() {
  const [currentTheme] = useState(initialTheme);
  return (
    <ChakraProvider theme={currentTheme}>
      <FinanceProvider>
        <AppRoutes theme={currentTheme} />
      </FinanceProvider>
    </ChakraProvider>
  );
}
